import { useEffect, useState } from "react";
import { getSentinelStatus } from "../../services/apiV2";

export default function TrustBadge() {
    const [status, setStatus] = useState("LOADING");

    const fetchStatus = () => {
        getSentinelStatus()
            .then((res) => {
                const computed =
                    res?.status ??
                    res?.state ??
                    res?.health ??
                    res?.sentinel_status ??
                    (typeof res?.trust_score === "number"
                        ? (res.trust_score >= 90 ? "HEALTHY" : "COMPROMISED")
                        : null) ??
                    "UNKNOWN";
                setStatus(computed);
            })
            .catch((err) => setStatus(err.message));
    };

    useEffect(() => {
        fetchStatus();
        const interval = setInterval(fetchStatus, 5000);
        return () => clearInterval(interval);
    }, []);

    const getColor = () => {
        if (status === "HEALTHY") return "#00FF94";
        if (status === "COMPROMISED") return "#FF003C";
        if (status === "UNAUTHORIZED") return "#FF8C00";
        if (status === "RATE_LIMITED") return "#FF8C00";
        if (status.startsWith("SERVER_ERROR")) return "#FF003C";
        return "#888";
    };

    const color = getColor();

    return (
        <div style={{
            padding: "18px 28px",
            borderRadius: "14px",
            background: "#050505",
            border: `1px solid ${color}`,
            color: color,
            fontFamily: "monospace",
            display: "inline-flex",
            alignItems: "center",
            gap: "14px",
            boxShadow: `0 0 12px ${color}33`
        }}>
            <div style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: color,
                boxShadow: `0 0 10px ${color}`
            }} />
            Oracle V2 Status: {status}
        </div>
    );
}
